import React from 'react'
import Summarize from '../pages/Summarize'

const SummarizeApp = () => {
  return (
    <div>
        <div className='main '>
        <div className='gradient' />
        </div>

      <div className='app'>
        <Summarize />
      </div>
    </div>
  )
}

export default SummarizeApp